import { render, staticRenderFns } from "./AddForm.vue?vue&type=template&id=d84e8d9c&scoped=true&"
import script from "./AddForm.vue?vue&type=script&lang=js&"
export * from "./AddForm.vue?vue&type=script&lang=js&"
import style0 from "./AddForm.vue?vue&type=style&index=0&id=d84e8d9c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84e8d9c",
  null
  
)

export default component.exports